import axios from 'axios';
import { Dispatch } from 'redux';
import {
  getUnsignedApprovalDocDownloadDetails,
  getSignedApprovalDocDownloadDetails,
} from '../../graphql/queries';
import {
  GET_ASSIGNED_APPROVAL_DOCS_REQUESTED,
  GET_ASSIGNED_APPROVAL_DOCS_COMPLETED,
  GET_ASSIGNED_APPROVAL_DOCS_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

const getAssignedApprovalDocAction =
  (
    ApprovalDocID: string,
    document: { DocFileName: string },
    ContactID: string,
  ) =>
  async (dispatch: Dispatch) => {
    let payload = {};

    dispatch({
      type: GET_ASSIGNED_APPROVAL_DOCS_REQUESTED,
    });
    try {
      if (document.DocFileName) {
        const { data } = await api.graphql({
          query: getSignedApprovalDocDownloadDetails,
          variables: {
            ApprovalDocID: document.DocFileName,
          },
        });

        if (data.getSignedApprovalDocDownloadDetails?.Url) {
          const s3Response = await axios.get<{ data: Blob }>(
            data.getSignedApprovalDocDownloadDetails.Url,
            { responseType: 'blob' },
          );

          const file = {
            Blob: s3Response.data,
            FileName: 'Financial Planning Agreement.pdf',
          };

          payload = {
            data: data.getSignedApprovalDocDownloadDetails,
            file,
          };
        }
      } else {
        const { data } = await api.graphql({
          query: getUnsignedApprovalDocDownloadDetails,
          variables: {
            ContactID,
            ApprovalDocID,
          },
        });
        if (data.getUnsignedApprovalDocDownloadDetails?.DocUrl) {
          debug('data', data.getUnsignedApprovalDocDownloadDetails.DocUrl);
          const bucketResponse = await axios.get<{ data: Blob }>(
            data.getUnsignedApprovalDocDownloadDetails.DocUrl,
            {
              responseType: 'blob',
            },
          );
          debug('document response', bucketResponse);

          const file = {
            FileName: data.getUnsignedApprovalDocDownloadDetails.DocFileName,
            Blob: bucketResponse.data,
          };

          payload = {
            data: data.getUnsignedApprovalDocDownloadDetails,
            file,
          };
          debug('file', file);
        }
      }

      dispatch({
        type: GET_ASSIGNED_APPROVAL_DOCS_COMPLETED,
        payload,
      });
    } catch (err) {
      debug(GET_ASSIGNED_APPROVAL_DOCS_FAILED, err);

      dispatch({
        type: GET_ASSIGNED_APPROVAL_DOCS_FAILED,
        payload: err,
      });
    }
  };

export default getAssignedApprovalDocAction;
